module.exports = __webpack_public_path__ + "img/riviera-coba.141627ae.jpg";